/* eslint-disable react/require-default-props */
import React, { FC } from 'react';
import classNames from 'classnames';

import './CaptionsCue.scss';

export interface CaptionsCueProps {
  playerBarActive?: boolean;
  lines?: string[];
}

const CaptionsCue: FC<CaptionsCueProps> = ({ playerBarActive, lines }) => {
  if (!lines?.length) {
    return null;
  }

  return (
    <div className={classNames('CaptionsCue', { 'playerbar-active': playerBarActive })}>
      {lines.map((l, i) => (
        <div key={`line-${i}`} className="CaptionsCue-line">
          {l}
        </div>
      ))}
    </div>
  );
};

export default CaptionsCue;
